import { ClassNameMap, Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import {
  secondaryTeceoFontFamily,
  teceoGrayPrimary,
  teceoGraySecondary,
  teceoGreen,
} from './Theme';
import { OUR_BRAND_NAME } from './modules/reports/utils/consts';
import { TITLE_HEIGHT } from './utils/constants';

export const upperTitleSize = 10;

export const truncateTwoLinesStyles: ClassNameMap<any> = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: '2',
  WebkitBoxOrient: 'vertical',
  whiteSpace: 'pre-wrap',
};

const useTeceoStyles = makeStyles({ name: OUR_BRAND_NAME })((theme: Theme) => ({
  variantBody1: {
    fontSize: '16px',
  },
  variantBody2: {
    fontSize: '14px',
  },
  clickable: {
    cursor: 'pointer',
  },
  primary: {
    color: theme.palette.primary.main,
  },
  graySecondary: {
    color: teceoGraySecondary,
  },
  grayPrimary: {
    color: teceoGrayPrimary,
  },
  secondaryTypography: {
    fontFamily: secondaryTeceoFontFamily,
  },
  secondary: {
    color: theme.palette.secondary.main,
  },
  textSecondary: {
    color: theme.palette.text.secondary,
  },
  tertiary: {
    color: teceoGreen,
  },
  noPaddingY: {
    paddingBottom: 0,
    paddingTop: 0,
  },
  svgIcon: {
    marginBottom: theme.spacing(-1 / 2),
  },
  upperTitle: {
    fontSize: upperTitleSize,
    color: theme.palette.grey[600],
    textTransform: 'uppercase',
    letterSpacing: 2,
    fontWeight: 300,
  },
  noTextTransform: {
    textTransform: 'none',
    '& .MuiButtonBase-root': {
      textTransform: 'none',
    },
  },
  lowercase: {
    textTransform: 'lowercase',
  },
  uppercase: {
    textTransform: 'uppercase',
  },
  capitalize: {
    textTransform: 'capitalize',
  },
  lightText: {
    fontWeight: 300,
  },
  regularText: {
    fontWeight: 400,
  },
  semiBoldText: {
    fontWeight: 500,
  },
  boldText: {
    fontWeight: 600,
  },
  borderRadius: {
    borderRadius: theme.shape.borderRadius,
  },
  tag: {
    borderRadius: theme.spacing(2),
    fontSize: theme.typography.caption.fontSize,
    height: theme.spacing(3),
  },
  tableContainerOptimezedToMargin: {
    '& .MuiTableRow-root': {
      height: theme.spacing(7),
      '& .MuiTableCell-root:first-of-type': {
        paddingLeft: theme.spacing(1),
      },
      '& .MuiTableCell-root:last-child': {
        paddingRight: theme.spacing(1),
      },
    },
  },
  tableContainerOptimezedToModal: {
    '& .MuiTableRow-root': {
      '& .MuiTableCell-root': {
        paddingTop: '9px',
        paddingBottom: '9px',
      },
      '& .MuiTableCell-root:last-child': {
        paddingRight: theme.spacing(3),
      },
    },
  },
  tableContainer: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    '& .MuiTableRow-root': {
      height: theme.spacing(6),
      '& .MuiTableCell-root:first-of-type': {
        paddingLeft: theme.spacing(1),
      },
      '& .MuiTableCell-root:last-child': {
        paddingRight: theme.spacing(1),
      },
    },
  },

  tableTextAction: {
    '&:hover': {
      textDecoration: 'underline',
      textDecorationColor: theme.palette.text.secondary,
    },
    cursor: 'pointer',
  },
  tableCellAction: {
    padding: 0,
  },
  titleContainer: {
    height: TITLE_HEIGHT,
  },
  verticalFlip: {
    transform: 'scaleY(-1)',
  },
  link: {
    textDecoration: 'none',
    color: theme.palette.text.primary,
  },
  linkDisguised: {
    textDecoration: 'none',
    color: 'inherit',
    '&:hover': {
      color: theme.palette.text.primary,
    },
  },
  dashedBorder: {
    border: '2px dashed',
    borderColor: theme.palette.primary.main,
  },
  subAppBar: {
    borderTop: `1px solid ${theme.palette.grey[300]}`,
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    zIndex: 1000,
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
    zIndex: theme.zIndex.appBar,
  },
  truncate: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  truncateTwoLines: truncateTwoLinesStyles,
  truncateOneLine: {
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitLineClamp: 1,
    lineClamp: 1,
    WebkitBoxOrient: 'vertical',
  },
  sectionTitle: {
    textTransform: 'capitalize',
    [theme.breakpoints.between('xs', 'md')]: {
      maxWidth: '30ch',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  },
  hideScrollbar: {
    '&::-webkit-scrollbar-thumb': {
      display: 'none',
    },
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    overflowX: 'auto',
  },
}));

export default useTeceoStyles;
